import { useQuery } from "@tanstack/react-query";

import stellar from "@/services/stellar";
import type { MaterialGroup } from "../types";

export const MATERIAL_GROUPS_QUERY_KEY = ["material-groups"] as const;

const fetchMaterialGroups = async () => {
  const { materialGroups } = (await stellar.action("getAllMaterialGroup")) as {
    materialGroups: MaterialGroup[];
  };

  return materialGroups;
};

export const useMaterialGroupsQuery = () =>
  useQuery({
    queryKey: MATERIAL_GROUPS_QUERY_KEY,
    queryFn: fetchMaterialGroups,
  });
